module.exports = __webpack_public_path__ + "static/media/Gotham-Book.527391b7.woff2";